/*============Get Auth programHistory Controller================================*/
angular
  .module('vppApp')
  .controller('viewAuthController', viewAuthController);

viewAuthController.$inject = ['$rootScope', '$scope', 'apiFactory', '$stateParams', 'vppConfig', 'dateFilter', 'dobFilter', 'AuthenticationService', 'CustomerService', '$timeout', '$state', 'ProgramInfoService', 'TimeOutService', 'VarientService', 'VehicleDetailService', '$filter'];

function viewAuthController($rootScope, $scope, apiFactory, $stateParams, vppConfig, dateFilter, dobFilter, AuthenticationService, CustomerService, $timeout, $state, ProgramInfoService, TimeOutService, VarientService, VehicleDetailService, $filter) {
  var accountId = AuthenticationService.getAuthenticatedID();
  var programOrder = vppConfig.programOrder[vppConfig.folderPath];
  var overviewRuleAlt = vppConfig.overviewRulesText;
  $scope.userSuspended = false;
  var pageNumber = 1;
  var programs = 'programs';
  var siteCode = vppConfig.folderPath;


  var overviewRulesCta;
  var thisCode,
    thisId,
    countId,
    arrayNumber,
    userData,
    varient,
    thisAuthHistory;

  $scope.programIDs = [];
  $scope.correctModalToOpen = 'authStatusTypesModalUrl' + vppConfig.folderPath;
  $scope.yourEmail = "noreply@gm.com";
  $scope.historyload = false;
  $scope.fullProgramIDs = [];
  $scope.programHistoryContainer = {};
  $scope.registeredCodes = [];
  $scope.firstName = '';
  $scope.$parent.firstName = '';

  CustomerService.loadedCallback(function () {

    var i = 0;
    var j = 1;
    $scope.programIDs = CustomerService.getProgramIDs();
    //console.log("$scope.programIDs init value: ", $scope.programIDs);

    //puts programs in specicic order order
    $scope.programIDs = $filter('sortProgramBy')($scope.programIDs, programOrder);
    $scope.firstName = CustomerService.getUserFirstName();
    $scope.$parent.firstName = $scope.firstName;


    if (siteCode === 'ded') {
      var tempDate = new Date();
      var userEmail = CustomerService.getUserEmail();
      userData = {
        'data': {
          'accountID': accountId,
          'lastAccessTime': tempDate
        }
      };
      AuthenticationService.setAuthentication(userData, userEmail);
    }

  });

  var retrieveProgramHistory = function (thisId, retrieveProgramHistorycallback) {

    apiFactory.authHistory(accountId, thisId, pageNumber).then(function (authHistoryResponse) {
      //console.log("apiFactory.authHistory: ", authHistoryResponse);
      $scope.programHistoryContainer[thisId] = {
        authHistory: [],
        totalNoOfAuths: 0,
        programID: thisId,
        loadedAuths: 0
      }

      if (authHistoryResponse) {
        $scope.programHistoryContainer[thisId]["authHistory"] = authHistoryResponse.data.authHistoryPart;
        $scope.programHistoryContainer[thisId]["totalNoOfAuths"] = authHistoryResponse.data.totalNoOfAuths;
        $scope.programHistoryContainer[thisId].loadedAuths = authHistoryResponse.data.authHistoryPart.length;

        // set DOB and zip code for each record
        var authHistoryLength = $scope.programHistoryContainer[thisId]["authHistory"].length;
        for (var i = 0; i < authHistoryLength; i++) {
          $scope.programHistoryContainer[thisId]['authHistory'][i].dob = $scope.programHistoryContainer[thisId]["authHistory"][i]["authDetails"]["Date of Birth"];
          $scope.programHistoryContainer[thisId]['authHistory'][i].zip = $scope.programHistoryContainer[thisId]["authHistory"][i]["authDetails"]["Postal Code"];
        }
      }

      getAuthProgram(thisId).then(function (response) {

        $scope.userSuspended = response.data.suspension;
        $scope.purchaserNameReq = response.data.purchaserNameReqFlag.toLowerCase();

        //console.log("name required ", response.data.moduleResponse.agencyConfigMap.kbv.examRequired);

        if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
          // console.log("$scope.programHistoryContainer[thisId]: ", $scope.programHistoryContainer[thisId]);
          retrieveProgramHistorycallback(response);
        }

      }, function errorCallback(response) {
        if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
          // console.log("$scope.programHistoryContainer[thisId]: ", $scope.programHistoryContainer[thisId]);
          retrieveProgramHistorycallback(null);
        }

      });

    }, function errorCallback(response) {
      // $scope.responsePending = false;
      // $scope.serverError = response.data.errors;
      TimeOutService.checkAuthError(response);
      if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
        retrieveProgramHistorycallback(null);
      }

    });

  };

  // runs when program accordion is clicked
  $scope.programAccordionToggle = function (id) {
    // reset the page number to verify we're getting
    // the first page of auth history records
    pageNumber = 1;
    getAuthHistoryForProgram(id);
    $scope.getRulesId(id);

    // register event handlers for the compliance overlay
    $timeout(function () {
      $scope.registerEventHandlers(id.code);
    }, 250);
  };

  var getAuthHistoryForProgram = function (id) {
    var key = 0;
    var programCount = $scope.programIDs.length;
    // Get auth history for each program
    // console.log("programCount: ", programCount);
    for (var i = 0; i < programCount; i++) {
      if (id.programID == $scope.programIDs[i].programID) {
        key = i;
        break;
      }
    }

    // get history if it hasn't been retreived yet
    if (typeof $scope.programHistoryContainer[$scope.programIDs[key].programID] == 'undefined') {
      $scope.programHistoryContainer[$scope.programIDs[key].programID] = {};

      retrieveProgramHistory($scope.programIDs[key].programID, function (retrieveProgramHistoryResponse) {

        if (retrieveProgramHistoryResponse) {
          $scope.programHistoryContainer[retrieveProgramHistoryResponse.data.programID]["programInfo"] = retrieveProgramHistoryResponse.data;

          bindAuthHistoryByProgram(id, key);
        }
      });
    }
  };

  var bindAuthHistoryByProgram = function (id, key) {

    // for (var i = 0; i < $scope.programIDs.length; i++) {

    $scope.programIDs[key]["programs"] = [{
      "authHistory": $scope.programHistoryContainer[$scope.programIDs[key].programID] ? $scope.programHistoryContainer[$scope.programIDs[key].programID]["authHistory"] : [],
      "totalNoOfAuths": $scope.programHistoryContainer[$scope.programIDs[key].programID] ? $scope.programHistoryContainer[$scope.programIDs[key].programID]["authHistory"].length : 0,
      "programID": $scope.programIDs[key].programID,
      "programInfo": $scope.programHistoryContainer[$scope.programIDs[key].programID]["programInfo"]
    }];

    var thisId = $scope.programIDs[key].programID;
    thisCode = $scope.programIDs[key].code;
    var idLower = thisCode.toLowerCase();
    $scope.pId = thisId;
    $scope.incetiveCode = $scope.programIDs[key].incentiveCode;

    var programs = 'programs';
    for (var x = 0; x < Object.keys(overviewRuleAlt).length; x++) {
      var pdfName = vppConfig.pdfNames[thisCode];
      var thisAltCode = Object.keys(overviewRuleAlt)[x];
      if (thisAltCode === idLower) {
        $scope.programIDs[key].overviewRulesCta = overviewRuleAlt[thisAltCode].text;
        $scope.programIDs[key].pdfPath = "/content/pdf/" + $scope.siteCode + "/" + overviewRuleAlt[thisAltCode].pdf + ".pdf";
        break;
      } else if (thisCode === 'UAWVPA') {
        $scope.programIDs[key].overviewRulesCta = 'Rules &amp; Guidelines';
        $scope.programIDs[key].pdfPath = "/content/pdf/" + $scope.siteCode + "/" + pdfName + ".pdf";
      } else {
        $scope.programIDs[key].overviewRulesCta = 'Rules &amp; Guidelines';
        $scope.programIDs[key].pdfPath = "/content/pdf/" + $scope.siteCode + "/GM-Rules-" + pdfName + ".pdf";
      }
    }

    if (thisCode.indexOf('SOTY') > -1) {
      // varient = 'soty';
      // VarientService.addVarient(varient);
      //sets the above variable in local storage to be used again

    } else if (thisCode.indexOf('HBCASH') > -1) {
      varient = 'hbcash';
      VarientService.addVarient(varient);
    }


    if ($scope.programIDs[key][programs][0].totalNoOfAuths < 10) {
      $scope.programIDs[key][programs][0].authHistory.showLoadMoreButton = false;
    } else {
      $scope.programIDs[key][programs][0].authHistory.showLoadMoreButton = true;
    }

    $timeout((function () {
      addLoadedFlag($scope.programIDs[key].code);
    })(key), 1000);

    $scope.historyload = true;

    // };

  };

  var bindAuthHistory = function () {

    for (var i = 0; i < $scope.programIDs.length; i++) {

      $scope.programIDs[i]["programs"] = [{
        "authHistory": $scope.programHistoryContainer[$scope.programIDs[i].programID] ? $scope.programHistoryContainer[$scope.programIDs[i].programID]["authHistory"] : [],
        "totalNoOfAuths": $scope.programHistoryContainer[$scope.programIDs[i].programID] ? $scope.programHistoryContainer[$scope.programIDs[i].programID]["authHistory"].length : 0,
        "programID": $scope.programIDs[i].programID,
        "programInfo": $scope.programHistoryContainer[$scope.programIDs[i].programID]["programInfo"]
      }];

      var thisId = $scope.programIDs[i].programID;
      thisCode = $scope.programIDs[i].code;
      var idLower = thisCode.toLowerCase();
      $scope.pId = thisId;
      $scope.incetiveCode = $scope.programIDs[i].incentiveCode;

      var programs = 'programs';
      for (var x = 0; x < Object.keys(overviewRuleAlt).length; x++) {
        var pdfName = vppConfig.pdfNames[thisCode];
        var thisAltCode = Object.keys(overviewRuleAlt)[x];
        if (thisAltCode === idLower) {
          $scope.programIDs[i].overviewRulesCta = overviewRuleAlt[thisAltCode].text;
          $scope.programIDs[i].pdfPath = "/content/pdf/" + $scope.siteCode + "/" + overviewRuleAlt[thisAltCode].pdf + ".pdf";
          break;
        } else {
          $scope.programIDs[i].overviewRulesCta = 'Rules &amp; Guidelines';
          $scope.programIDs[i].pdfPath = "/content/pdf/" + $scope.siteCode + "/GM-Rules-" + pdfName + ".pdf";
        }
      }

      if (thisCode.indexOf('SOTY') > -1) {
        // varient = 'soty';
        // VarientService.addVarient(varient);
        //sets the above variable in local storage to be used again

      } else if (thisCode.indexOf('HBCASH') > -1) {
        varient = 'hbcash';
        VarientService.addVarient(varient);
      }


      if ($scope.programIDs[i][programs][0].totalNoOfAuths < 10) {
        $scope.programIDs[i][programs][0].authHistory.showLoadMoreButton = false;
      } else {
        $scope.programIDs[i][programs][0].authHistory.showLoadMoreButton = true;
      }

      $timeout((function (i) {
        addLoadedFlag($scope.programIDs[i].code);
      })(i), 1000);

      $scope.historyload = true;

    };
  };

  $scope.loadMoreAuths = function (id) {
    thisId = id.programID;
    thisCode = id.code;


    removeLoadedFlag(thisCode);
    // console.log("id: ", id);
    // console.log("thisId: ", thisId);
    // console.log("$scope.programIDs: ", $scope.programIDs);

    for (var i = 0; $scope.programIDs.length > i; i++) {
      var programNumber = $scope.programIDs[i].programID;
      if (programNumber === thisId) {
        arrayNumber = i;
      }
    }
    // console.log("arrayNumber: ", arrayNumber);

    pageNumber = ($scope.programIDs[arrayNumber]["programs"][0].authHistory.length / 10) + 1;

    // console.log("what is the current pageNumber: ", pageNumber);
    apiFactory.authHistory(accountId, thisId, pageNumber).then(function (authHistoryResponse) {
      // console.log("apiFactory.authHistory: ", authHistoryResponse);

      // remove button if less than 10 results are returned from the API
      $scope.programHistoryContainer[thisId].loadedAuths += authHistoryResponse.data.authHistoryPart.length;

      if ($scope.programHistoryContainer[thisId].loadedAuths === authHistoryResponse.data.totalNoOfAuths) {
        $scope.programIDs[arrayNumber]["programs"][0].authHistory.showLoadMoreButton = false;
      }

      (function (arrayNumber) {
        //console.log("id: ", id);
        var newHistory = authHistoryResponse.data.authHistoryPart;
        //console.log("newHistory: ", newHistory.length);
        //console.log("arrayNumber: ", arrayNumber);


        for (var i = 0; i < 10; i++) {
          // console.log("newHistory[i]: ", newHistory[i]);
          if (newHistory[i]) {
            $scope.programIDs[arrayNumber]["programs"][0].authHistory.push(authHistoryResponse.data.authHistoryPart[i]);
          }
        }

        addLoadedFlag(thisCode);
      })(arrayNumber);

    });

  };

  var removeLoadedFlag = function (thisCode) {
    var removeAuthElements = document.getElementsByClassName(thisCode);
    Array.prototype.forEach.call(removeAuthElements, function (el) {
      el.classList.remove('loaded');
    })
  };

  var addLoadedFlag = function (thisCode) {
    var authElements = document.getElementsByClassName(thisCode);
    Array.prototype.forEach.call(authElements, function (el) {
      el.classList.add('loaded');
    })
  };

  $scope.passGas = function (data, programInfo, id) {
    $scope.thisAuthNum = data.authorizationNumber;
    $scope.thisIncentCode = data.incentiveCode;
    $scope.thisTagId = data.accountDetail;
    $scope.authDetails = data.authDetails;
    $scope.expirationDate = data.expirationDate;
    $scope.relationship = data.relationship;
    $scope.programInfo = programInfo;
    $scope.fields = {};
    if (data.authDetails) {
      $scope.fields.dob = (typeof data.authDetails.dateOfBirth === 'undefined' ? "" : data.authDetails.dateOfBirth.replace(/\//g, ''));
      $scope.fields.zip = (typeof data.authDetails.postalCode === 'undefined' ? "" : data.authDetails.postalCode);
      $scope.fields.relationship = data.relationship;
    }

    if (id) {
      setProgramSpecificVars(id.code);
    }
  };

  $scope.gotToAuth = function (id) {
    apiFactory.authProgram(accountId, id.programID).then(function (response) {
      $scope.programInfo = response.data;
      $scope.KBVExam = $scope.programInfo.moduleResponse.agencyConfigMap.kbv ? true : false;
      // console.log($scope.programInfo.programs[0].programInfo.moduleResponse.agencyConfigMap.kbv);
      ProgramInfoService.addProgram(id);
      if ($scope.KBVExam) {
        $state.go('obtainauth');
      } else {
        if ($scope.siteCode == 'frd' || $scope.siteCode == 'mpp' || $scope.siteCode == 'gmed') {
          $rootScope.isRegistration = false;
          apiFactory.idMeVerifyUser(accountId).then(function successCallback(response) {
            $state.go('get-auth');
          }, function errorCallback(response) {
            $scope.responsePending = false;
            $scope.serverError = response.data.errors;
            $state.go('sign-in');
          });
        } else {
          $state.go('get-auth');
        }
      }
    }, function (response) {
      //console.log('authprogram error', response);
      if (response.data.errors[0].errorCode == '9050' || response.data.remainingEntitlements == 0) {
        $scope.entitlementsExceeded = true;
      }

      TimeOutService.checkAuthError(response);
    });
  };


  $scope.voidAuth = function () {
    // var accountId = AuthenticationService.getAuthenticatedID();
    var authorizationCode = $scope.thisAuthNum + "-" + $scope.thisIncentCode;

    apiFactory.authVoid(accountId, authorizationCode).then(function () {
      $scope.toggleModal();
      $state.reload();

    }, function errorCallback(response) {
      $scope.responsePending = false;
      $scope.serverError = response.data.errors;

    });
  };

  $scope.submitAuthEdit = function (form) {
    $scope.responsePending = true;
    // console.log(form);
    // console.log('sumbit fields', $scope.fields.dob, $scope.fields.zip, $scope.fields.relationship);
    // var accountId = AuthenticationService.getAuthenticatedID();
    var _secondaryPassword = (($scope.userSuspended === true) ? $scope.fields.secondaryPassword : "string");
    var authorizationCode = $scope.thisAuthNum + "-" + $scope.thisIncentCode;
    var editInfo = {
      "authDetails": {
        "dateOfBirth": dobFilter($scope.fields.dob)
      },
      "secondaryPassword": _secondaryPassword,
      "relationship": $scope.fields.relationship
    };
    if ($scope.useCanadaZip) {
      // editInfo.authDetails["postalCodeUSCanada"] = $scope.fields.zip
      editInfo.authDetails.postalCode = $scope.fields.zip
    } else {
      editInfo.authDetails.postalCode = $scope.fields.zip
    }

    apiFactory.authEdit(accountId, authorizationCode, editInfo).then(function () {
      $scope.responsePending = false;
      $scope.toggleModal();
      $state.reload();
    }, function errorCallback(response) {
      console.log('authEdit error', response);
      $scope.responsePending = false;
      $scope.serverError = response.data.errors;
    });
  };

  $scope.submitForm = function (email) {
    // var accountId = AuthenticationService.getAuthenticatedID();
    var authorizationCode = $scope.thisAuthNum + "-" + $scope.thisIncentCode;
    var emailInfo = email;

    apiFactory.authEmail(accountId, authorizationCode, emailInfo).then(function () {
      $scope.toggleModal();
      $scope.toggleModal('emailSentConfirmation');
    }, function errorCallback(response) {
      $scope.responsePending = false;
      $scope.serverError = response.data.errors;

    });
  };

  $scope.getRulesId = function (id) {
    var pCode = id.code;
    $scope.pdfName = vppConfig.pdfNames[pCode];
  };

  $scope.goOverview = function (id) {
    var programName = id.name;
    $scope.programInfo = id;
    ProgramInfoService.addProgram(id);
    $state.go('overview');

  };

  $scope.voidTag = function () {
    var tagID = $scope.thisTagId;

    $timeout(function () {
      var programIds = CustomerService.getProgramIDs();
      var programID;
      for (var i = 0; i < programIds.length; i++) {
        if (programIds[i].code.toLowerCase() === 'vts') {
          programID = programIds[i].programID;
        }
      }

      apiFactory.vtTagVoid(accountId, programID, tagID).then(function () {
        $scope.toggleModal();
        $state.reload();
      }, function errorCallback(response) {
        $scope.responsePending = false;
        $scope.serverError = response.data.errors;
      });
    }, 1000);
  };

  $scope.goodwillConfirm = function () {
    $scope.toggleModal();
    window.location = vppConfig.domainName + '/vpprs/integrated-login?r=' + Math.ceil(Math.random() * 100000);
  };

  var getAuthProgram = function (programID) {
    // var accountId = AuthenticationService.getAuthenticatedID();
    return apiFactory.authProgram(accountId, programID);
  };

  $scope.passPopUpTitle = function (title) {
    $scope.popUpConfirmationTitle = title;
  };

  $scope.goToVehicleDetail = function (vin) {
    VehicleDetailService.destroyVehicleDetailVin();
    VehicleDetailService.setVehicleDetailVin(vin);
    $state.go('vehicle-tag-detail', { from: $state.current.name });
  };

  var setProgramSpecificVars = function (progCode) {
    var _templateType = '';
    $scope.useCanadaZip = false; // default value
    switch (progCode.toLowerCase()) {
      case 'gms':
      case 'yos5':
      case 'yos20':
      case 'lti':
      case 'gmevtour':
      case 'gmevtourev':
        _templateType = "template-a";
        $scope.useCanadaZip = true;
        $scope.govEmployee = true;
        break;

      case 'accdisc':
        _templateType = "template-a";
        $scope.useCanadaZip = true;
        break;

      case 'sdff2':
      case 'sdff2ev':
        _templateType = "template-b";
        break;

      case 'sdff2sf':
        _templateType = "template-b";
        break;

      case 'gmcs':
      case 'gmcsv':
        _templateType = "template-c";
        break;

      case 'mktexec':
      case 'usexec':
      case 'evexec':
      case 'gmfexec':
      case 'ltiexec':
        _templateType = "template-d";
        $scope.useCanadaZip = true;
        break;

      case 'gmsdd':
        _templateType = "template-e";
        // $scope.requireRelationshipAgree = true;
        break;

      case 'appcert1g':
      case 'appcert2g':
      case 'appcert3g':
      case 'gmfappcert1g':
      case 'gmfappcert2g':
      case 'gmfappcert3g':
      case 'gmeac':
        $scope.authTemplateType = "template-f";
        $scope.useCanadaZip = true;
        break;

      case 'pep':
        $scope.authTemplateType = "template-g";
        $scope.useCanadaZip = true;
        // $scope.requireRelationshipAgree = true;
        break;

      case 'pepcont':
        $scope.authTemplateType = "template-g";
        $scope.useCanadaZip = true;
        // $scope.requireRelationshipAgree = true;
        break;

      case 'gmsani':
        $scope.authTemplateType = "template-h";
        // modulefilename = 'emp/get-auth-template-h.html';
        break;

      case 'svpp2':
      case 'spl2':
      case 'spl2ev':
      case 'cgp':
      case 'gmed':
        $scope.authTemplateType = "template-default";
        break;

      case 'gmdlr':
      case 'gmdlr3':
      case 'gmdlrev':
        // no TPL
        $scope.authTemplateType = "template-no-tpl";
        break;

      default:
        $scope.authTemplateType = "template-default";
        break;
    }
  };

  $scope.registerEventHandlers = function (code) {
    var inRegisteredHandlers = $scope.registeredCodes.indexOf(code) > -1;
    // only register if it hasn't already been registered
    if (!inRegisteredHandlers) {
      // get elements
      var accordion = document.getElementsByClassName(code)[0];
      var programContent = accordion.querySelector('.program-content-' + code);
      var content = document.getElementsByClassName('compliance-content-' + code)[0];
      var scrollbox = content.querySelector('.compliance-rules-' + code);
      var button = content.querySelector('.compliance-button-' + code);

      // create scroll event handler
      scrollbox.addEventListener('scroll', function () {
        // console.log('add ' + code + ' scroll event listener');
        if ((scrollbox.scrollTop + scrollbox.offsetHeight) >= scrollbox.scrollHeight) {
          button.disabled = false;
        }
      });
      // create click event handler
      button.addEventListener('click', function () {
        $(content).fadeOut(250);
        $(programContent).fadeIn(250);
        $([document.documentElement, document.body]).animate({
          scrollTop: $(accordion).offset().top - 110
        }, 250);
        accordion.classList.remove('has-compliance-content');
      });
    }

    // add code to registeredCodes array
    $scope.registeredCodes.push(code);
  };

  // copied from getAuthController
  $scope.getRulesnConditions = function (code) {
    var _theRulesTemplate;
    var _templatefilename;

    switch (code.toLowerCase()) {
      case 'pep':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-pep.html';
        break;

      case 'pepcont':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-pepcont.html';
        break;

      case 'gmsdd':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsdd.html';
        break;

      case 'sdff2':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-supplier-discount-for-friends.html';
        break;

      case 'sdff2ev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-sdff2ev.html';
        break;

      case 'sdff2sf':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-supplier-discount-for-friends.html';
        break;

      case 'gmsani':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsani.html';
        break;

      case 'mktexec':
      case 'usexec':
      case 'ltiexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-exec-program.html';
        break;

      case 'evexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-evexec.html';
        break;

      case 'yos5':
      case 'yos20':
      case 'gms':
      case 'gmevtour':
      case 'gmevtourev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-yos-gms-program.html';
        break;

      case 'gmsev':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-gmsev.html';
        break;

      case 'gmfexec':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-financial-exec-program.html';
        break;

      case 'uawvpa':
        _templatefilename = 'emp/get-auth-rules-and-guidelines-uaw.html';
        break;

      default:
        _templatefilename = 'emp/get-auth-rules-and-guidelines.html';
        break;
    }

    _theRulesTemplate = vppConfig.authorizationContentPath + _templatefilename;

    return _theRulesTemplate;
  };

  // var onCustomerChange = function (customer) {
  //   if (customer) {
  //     $scope.programIDs = $filter('sortProgramBy')(customer.programIDs, programOrder) || [];
  //     $scope.firstName = customer.firstName;
  //     $scope.$parent.firstName = $scope.firstName;

  //     $scope.programIDs.forEach(program => {

  //       getProgramInfo(program);

  //     });

  //   } else {
  //     $scope.programIDs = [];
  //   }
  // };

  // CustomerService.addObserver(onCustomerChange);

  // $scope.$on("$destroy", function () {
  //   CustomerService.removeObserver(onCustomerChange);
  // });

}